import { Box, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { WarningTriangle } from 'iconoir-react';
import { useTranslation } from 'react-i18next';

interface PlacementConflictNoticeProps {
  adSetName: string;
}

/**
 * Advisory warning: the same post already delivers in the selected campaign, so
 * the two ads would compete in the auction. Never blocking — the brand may have
 * a good reason, and the ticket is explicit that the launch stays possible.
 */
export function PlacementConflictNotice({ adSetName }: PlacementConflictNoticeProps) {
  const { t } = useTranslation();

  return (
    <Box
      border="1px solid"
      borderColor="yellow.emphasized"
      bg="yellow.subtle"
      rounded="lg"
      px={3}
      py={2.5}
    >
      <HStack align="flex-start" gap={2}>
        <Icon size="sm" color="yellow.fg" mt={0.5}>
          <WarningTriangle />
        </Icon>
        <VStack align="stretch" gap={1}>
          <Text fontSize="sm" fontWeight="semibold" color="yellow.fg">
            {t('mentions.boost.setup.placement.conflictTitle')}
          </Text>
          <Text fontSize="xs" color="yellow.fg">
            {t('mentions.boost.setup.placement.conflictBody', { adSetName })}
          </Text>
          <Text fontSize="xs" color="fg.muted">
            {t('mentions.boost.setup.placement.conflictFooter')}
          </Text>
        </VStack>
      </HStack>
    </Box>
  );
}
